<!-- eslint-disable -->
<template>
  <div class="ask-meeting">
    <div v-if="isUploading" class="spin-container">
      <a-spin size="large" tip="文件上传中" />
    </div>
    <a-row>
      <a-col :span="12">
        <div class="content-item">
          <div class="item-title">项目状态：</div>
          <div>{{ stateName }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="content-item">
          <div>{{ projectTypeName }}</div>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <div class="content-item">
          <div class="item-title">deal leader：</div>
          <div>{{ dealLeader }}</div>
        </div>
      </a-col>
      <a-col :span="12">
        <div class="content-item">
          <div class="item-title">deal member：</div>
          <div>{{ dealMember }}</div>
        </div>
      </a-col>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <div class="content-item brief">
        <a-col :span="4">
          <div class="item-title ant-form-item-required">一句话描述：</div>
        </a-col>
        <a-col :span="14">
          <a-input v-model="meetingDescription" :disabled="!!editMeetingId"></a-input>
        </a-col>
        <a-col :span="6">
          <a class="info" v-if="!editMeetingId" style="margin-left: 12px" @click="meetingDescription = description">一键填充项目描述</a>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="14" :offset="4" class="info">
        <a-icon type="exclamation-circle" theme="filled" class="brief-info-icon" />
        项目一句话描述将会同步到Investor team飞书群供大家报名参考，如有改动请点击修改即可
      </a-col>
    </a-row>
    <a-row v-if="askMeetingType !== 2 && projectInfo.base.financingStage === 1">
      <div class="content-item lh-32">
        <a-col :span="4">
          <div class="item-title ant-form-item-required">注册情况：</div>
        </a-col>
        <a-col :span="14">
          <span v-if="project.thirdCompanyId && project.registerAreaFromXiniu">已注册（数据取自烯牛）</span>
          <span v-else-if="project.thirdCompanyId && !project.registerAreaFromXiniu">未注册（数据取自烯牛）</span>
          <a v-else>暂未绑定烯牛项目</a>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <div class="content-item lh-32">
        <a-col :span="4">
          <div class="item-title ant-form-item-required">注册地(区)：</div>
        </a-col>
        <a-col :span="18">
          <div v-if="project.registerAreaFromXiniu">{{ project.registerAreaFromXiniu }}（数据取自烯牛）</div>
          <a-input v-model="registerArea" placeholder="请输入" style="width: 100%" :disabled="!!editMeetingId"> </a-input>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <div class="content-item lh-32">
        <a-col :span="4">
          <div class="item-title ant-form-item-required">落地诉求：</div>
        </a-col>
        <a-col :span="18">
          <a-textarea
            :rows="3"
            v-model="registerRequire"
            placeholder="之前有上会项目回复没需求，实际IC跟公司聊得时候，已经有多个政府在竞争，其他投资机构也推荐了不少地方。为了避免这类情况，我们会尽量详细收集信息，请大家询问公司，不要主观判断，谢谢理解"
            class="input"
            :disabled="!!editMeetingId"
          >
          </a-textarea>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="askMeetingType !== 2 && projectInfo.base.financingStage !== 1">
      <div class="content-item lh-32">
        <a-col :span="4">
          <div class="item-title ant-form-item-required">跟投情况：</div>
        </a-col>
        <a-col :span="18">
          <a-input :disabled="!!editMeetingId" v-model="followOnInfo" placeholder="请输入" class="input"> </a-input>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="showVentureSource" class="m-t-8">
      <div class="content-item brief">
        <a-col class="w-22">
          <div class="item-title ant-form-item-required">首次soucing方式：</div>
        </a-col>
        <a-col :span="14">
          <a-select :disabled="!!editMeetingId" v-model="sourceType" style="width:100%">
            <a-select-option v-for="i in sourceTypes" :key="i.id" :value="i.id">{{ i.name }}</a-select-option>
          </a-select>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="showVentureSource">
      <a-col :span="18" class="info sourcing">
        <a-icon type="exclamation-circle" theme="filled" class="brief-info-icon" />
        请选择首次接触公司的source方式，而非首次投资公司时的source方式
      </a-col>
    </a-row>
    <a-row v-if="showVentureSource">
      <div class="content-item">
        <a-col class="w-22">
          <div class="item-title ">sourcing方式备注：</div>
        </a-col>
        <a-col :span="14">
          <a-input :disabled="!!editMeetingId" v-model="sourceRemark"></a-input>
        </a-col>
      </div>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="18">
        <div class="content-item">
          <div class="item-title ant-form-item-required">大赛道：</div>
          <a-select
            v-model="bigSector"
            mode="multiple"
            placeholder="项目所属大赛道（可多选）"
            :filterOption="false"
            notFoundContent="暂无数据"
            class="select"
            style="width: 510px"
          >
            <a-select-option v-for="v in bigSectorList" :key="v">{{ v }}</a-select-option>
          </a-select>
        </div>
      </a-col>
    </a-row>
    <a-divider></a-divider>
    <a-row>
      <a-col :span="16">
        <div class="content-item lh-32">
          <div class="item-title">会议类型：</div>
          <div v-if="askMeetingType">{{ askMeetingTypeMap[askMeetingType] }}会议</div>
          <div v-else>online会议</div>
        </div>
      </a-col>
    </a-row>

    <!-- 会议名称 -->
    <a-row v-if="askMeetingType === 2">
      <a-col :span="16">
        <div class="content-item lh-32 flex">
          <div class="item-title ant-form-item-required">会议名称：</div>
          <a-input v-model="meetingName"></a-input>
        </div>
      </a-col>
    </a-row>

    <!-- 项目阶段 -->
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="12">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">上会分类：</div>
          <a-cascader
            :options="meetingCategory"
            placeholder="请选择"
            @change="getMeetingCategory"
            class="select"
            popupClassName="meeting-category-class"
            :value="meetingCategoryType"
          />
        </div>
      </a-col>
      <a-col :span="12" class="info">
        <a-icon type="exclamation-circle" theme="filled" class="category-info-icon" />
        请严格按照项目阶段对照表选择分类
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="12">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">上会目的：</div>
          <a-select size="default" placeholder="请选择" class="select" :value="meetingGoal.name">
            <a-select-option v-for="(item, index) in meetingGoals" :key="index" :value="item.name" @click="getMeetingGoal(item)">{{
              item.name
            }}</a-select-option>
          </a-select>
        </div>
      </a-col>
    </a-row>
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="12">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">融资轮次：</div>
          <round-select :companyId="projectId" :type="needNewRound ? 1 : 2" v-model="projectRound" :disabled="!needNewRound" class="select"></round-select>
        </div>
      </a-col>
      <a-col :span="12" v-if="stage.phase === 1">
        <div class="content-item new-round lh-32">
          <div class="item-title">开启新轮次：</div>
          <a-checkbox :ckecked="newRoundChecked" @change="switchNew"></a-checkbox>
        </div>
      </a-col>
    </a-row>

    <a-row v-if="mustIpoRow">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">预计3年内IPO:</div>
          <a-radio-group v-model="ifIpo">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </div>
      </a-col>
    </a-row>

    <!-- 上市公司分拆 -->
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">上市公司分拆:</div>
          <a-radio-group v-model="subsidiary">
            <a-radio :value="1"> 是 </a-radio>
            <a-radio :value="0"> 否 </a-radio>
          </a-radio-group>
        </div>
      </a-col>
    </a-row>

    <!-- 上市公司名称 -->
    <a-row v-if="askMeetingType !== 2 && subsidiary === 1">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">上市公司名称:</div>
          <a-input class="related-company" v-model="relatedCompany" />
        </div>
      </a-col>
    </a-row>

    <a-row v-if="askMeetingType !== 2">
      <a-col :span="13" class="content-item lh-32">
        <div class="item-title ant-form-item-required">公开/保密：</div>
        <a-radio-group v-model="secret">
          <a-radio :value="item.value" v-for="item in secretMeetingTypeList" :key="item.value"> {{ item.label }}会议 </a-radio>
        </a-radio-group>
      </a-col>

      <a-col :span="10" class="secret-info content-item" v-if="secret !== undefined">
        <a-tooltip class="flex" placement="topLeft" overlayClassName="askmeeting-info-full">
          <template slot="title">
            {{ secretInfo }}
          </template>
          <a-icon type="exclamation-circle" theme="filled" />
          <div class="info-hide">{{ secretInfo }}</div>
        </a-tooltip>
      </a-col>
    </a-row>

    <!-- 需要时间 -->
    <a-row v-if="askMeetingType !== 2">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title">需要时间：</div>
          <a-input class="need-time" v-model="needTime" />
          <div class="need-time-unit">分钟</div>
        </div>
      </a-col>
    </a-row>

    <!-- 会议时间 -->
    <a-row v-if="askMeetingType === 2">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">会议时间：</div>
          <time-range-pick :meetingDate="meetingDate" :meetingTimeRange="[startTime, endTime]" @meetingTimeChange="meetingTimeChange"> </time-range-pick>
        </div>
      </a-col>
    </a-row>

    <a-row v-if="askMeetingType === 2">
      <a-col :span="24">
        <div class="content-item lh-32">
          <div class="item-title ant-form-item-required">选择飞书群：</div>
          <a-select @change="handleChange" placeholder="请选择飞书群" class="group-select" optionLabelProp="title">
            <a-select-option v-for="item in grouplist" :key="item.groupId" :value="item.groupId" :title="item.name">
              <div class="option-container">
                <a-avatar size="large" :src="item.avatar"></a-avatar>
                <div class="name-content">
                  <div class="name">{{ item.name }}</div>
                  <div class="description">{{ item.description }}</div>
                </div>
              </div>
            </a-select-option></a-select
          >
        </div>
      </a-col>
    </a-row>

    <!--产生vote&vote节点  -->
    <!-- <div class="content-item">
      <a-checkbox
        class="create-vote"
        @change="
          event => {
            this.isHasVote = event.target.checked ? 1 : 0;
          }
        "
        >是否需要在例会上产生Vote？</a-checkbox
      >
      <div v-if="isHasVote" class="item-title ant-form-item-required vote">Vote节点：</div>
      <a-auto-complete v-if="isHasVote" style="width: 200px" optionLabelProp="text" v-model="voteNode" placeholder="请输入vote节点">
        <template slot="dataSource">
          <a-select-option v-for="item in voteNodeList" :key="item.name" :text="item.name">
            {{ item.name }}
          </a-select-option>
        </template>
      </a-auto-complete>
    </div> -->
    <div class="support-div" v-if="supportShow">
      <div class="support-title">
        <div class="required">*</div>
        提供独立尽调报告部门：
      </div>
      <div class="support-content">
        <div v-for="(item, index) in supportList" :key="item.id">
          <!-- <a-checkbox class="checkbox" @change="checkChange(index, item)" :checked="item.checked" v-if="index !== 5">{{ item.name }}</a-checkbox> -->
          <a-checkbox class="checkbox" style="width: 160px" @change="checkChange(index, item)" :checked="item.checked" v-if="index === 5">{{
            item.name
          }}</a-checkbox>
          <a-checkbox class="checkbox" @change="checkChange(index, item)" :checked="item.checked" v-else-if="index === 4 || index === 8">{{
            item.name
          }}</a-checkbox>
          <a-checkbox class="checkbox" style="width: 80px" @change="checkChange(index, item)" :checked="item.checked" v-else>{{ item.name }}</a-checkbox>
        </div>
      </div>
    </div>
    <a-divider v-if="askMeetingType !== 2"></a-divider>
    <div class="upload" v-if="askMeetingType !== 2">
      <meeting-upload
        ref="meetingUpload"
        :round="projectRound"
        :isEdit="!!editMeetingId"
        :initChecklist="initChecklist"
        :companyId="projectId"
        :meetingGoal="meetingGoal"
      ></meeting-upload>
    </div>
    <!-- 更新文档 /-->
    <div class="bottom-container">
      <a-button type="primary" :disabled="submitDisable" @click="submit">确认</a-button>
    </div>
  </div>
</template>

<script>
import { getChecklist } from '@/api/project';
import { askMeeting, meetingStaticInfo, getEditMeetingInfo } from '@/api/meeting';
import { queryFeishuGroupList } from '@/api/companyGroup';

import meetingUpload from '@/components/project/meetingUpload';
import roundSelect from '@/components/base/roundSelect';
import timeRangePick from '@/components/meeting/timeRangePick.vue';

import moment from 'moment';

import { supportList } from '@/utils/meeting';
import { phaseMap, projectTypeMap, meetingCategory, stageGroupMap, meetingTypeList, secretMeetingTypeList, askMeetingTypeMap } from '@/utils/project';
import { VENTRURE_SOURCE_TYPES } from '@/const/common.js';
export default {
  name: 'askMeeting',
  components: { meetingUpload, roundSelect, timeRangePick },
  props: {
    projectId: {
      type: String,
      default() {
        return null;
      }
    },
    editMeetingId: {
      type: Number,
      default() {
        return null;
      }
    },
    projectInfo: {
      type: Object,
      default() {
        return {};
      }
    },
    historyStage: {
      type: Array,
      default() {
        return [];
      }
    },

    // 0: 'followon',
    // 1: 'online',
    // 2: 'offline'
    askMeetingType: {
      type: Number,
      default: 1
    }
  },
  watch: {
    supportShow() {
      if (!this.supportShow) {
        this.supportList.forEach(_ => {
          _.checked = false;
        });
      }
    }
    // relatedCompany() {
    //   let { base } = this.projectInfo;
    //   let { relatedCompany } = base;
    //   return relatedCompany;
    // },
  },
  computed: {
    secretInfo() {
      return this.secret
        ? '保密项目：由于dynamics较紧，DT仅邀请小范围同学参与讨论的项目。运营组根据参会领域标签邀请相关领域有贡献的同学参会，想旁听学习的同学也可通过运营组申请，但DT有权拒绝。项目释放后，推送交割/解密通知到Deal team大群，大家亦可学习。'
        : '公开项目：项目信息发布后，运营组默认邀请所有报名同学参会。';
    },
    showVentureSource() {
      return !this.projectInfo.ventureInfo.sourceType;
    },
    mustIpoRow() {
      return this.meetingCategoryType[0] === 3;
    },
    dealLeader() {
      let dl = this.projectInfo.member.dls[0] || {};
      return dl.nickname || '';
    },
    dealMember() {
      let dms = this.projectInfo.member.dms || [];
      return dms.map(_ => _.nickname).join(' ');
    },
    description() {
      let { base } = this.projectInfo;
      let { description } = base;
      return description;
    },
    project() {
      return {
        ...this.projectInfo.base,
        thirdCompanyId: this.projectInfo.base.hasBind ? -1 : null
      };
    },
    stage() {
      let { historyStage } = this;
      return historyStage.length ? historyStage[historyStage.length - 1] : {};
    },
    stateName() {
      let { phase, roundName } = this.stage;
      return `${roundName}轮${phaseMap[phase]}`;
    },
    projectTypeName() {
      let { base } = this.projectInfo;
      let { oldMark } = base;
      return `${projectTypeMap[oldMark]}`;
    },
    needNewRound() {
      return this.projectInfo.stage.phase === 0 || (this.projectInfo.stage.phase === 1 && this.newRoundChecked);
    },
    supportShow() {
      return (
        ((this.meetingCategoryType[1] === 6 || this.meetingCategoryType[1] === 1 || this.meetingCategoryType[1] === 2) &&
          (this.meetingGoal.id === 3 || this.meetingGoal.id === 4 || this.meetingGoal.id === 5)) ||
        ((this.meetingCategoryType[1] === 3 || this.meetingCategoryType[1] === 5) && this.meetingGoal.id !== 1 && this.meetingGoal.id !== 8) ||
        this.meetingGoal.id === 7
      );
    }
    // registerShow() {
    //   // return this.projectInfo.base.financingStage === 1 && this.askMeetingType === 1;
    //   return this.askMeetingType === 1;
    // }
  },
  data() {
    return {
      sourceTypes: VENTRURE_SOURCE_TYPES,
      meetingDescription: '',
      registerArea: '',
      registerRequire: '',
      followOnInfo: '',
      sourceType: undefined,
      sourceRemark: '',
      currentUser: this.$store.state.user.userInfo,
      needTime: 90, // onepager(id-2) 默认1.5小时，dd memo(id-3,4,5) 默认2小时
      subsidiary: 0,
      meetingCategoryType: [], //上报（上会分类）
      meetingGoal: {}, //上报（上会目的）
      projectRound: '', //选中的项目轮次
      initChecklist: [],
      checklist: [], //上报
      meetingGoals: [{ id: 1, name: 'mudishisha' }], // getCommonList接口动态获取
      // deletedFileIds: [],
      projectRounds: [], //项目轮次数组
      isHasVote: 0, //是否产生vote
      // voteNode: '',
      newRoundChecked: false,
      submitDisable: false,
      meetingType: 1,
      secret: undefined,
      meetingCategory,
      meetingTypeList,
      secretMeetingTypeList,
      supportList: supportList,
      isUploading: false,
      ifIpo: undefined,
      askMeetingTypeMap,
      meetingName: '',
      grouplist: [],
      groupId: '',
      startTime: 0,
      endTime: 0,
      relatedCompany: '',
      meetingDate: {},
      bigSector: [],
      bigSectorList: ['AI+', '大制造', '大消费', '生物医疗', '企业服务', '其他']
    };
  },
  async created() {
    let { base } = this.projectInfo;
    this.relatedCompany = base.relatedCompany || '';
    this.registerRequire = base.registerRequire;
    this.followOnInfo = base.followOnInfo;
    this.registerArea = base.registerArea;
    this.bigSector = base.bigSector;
    let nowDate = new Date().getTime();
    this.meetingDate = moment(nowDate);
    this.startTime = this.meetingDate
      .clone()
      .startOf('day')
      .add(9, 'h')
      .unix();
    await meetingStaticInfo().then(res => {
      const data = res.data;
      if (this.askMeetingType === 1) {
        this.meetingGoals = data['goals'].filter(_ => {
          return _.id !== 8;
        });
      } else if (this.askMeetingType === 2) {
        this.meetingGoals = data['goals'].filter(_ => {
          return _.id === 8;
        });
      } else {
        this.meetingGoals = data['goals'].filter(_ => {
          return _.id !== 8;
        });
      }
      // this.meetingCategory = data['category'];
      this.projectRounds = data.roundList;
      this.voteNodeList = data.decisionPoint;
    });
    this.gerGrouplist();
    if (this.editMeetingId) {
      //编辑
      this.editMeeting();
    } else {
      //新建
      // this.dealLeaders = [this.currentUser];
    }
  },
  mounted() {
    let _this = this;
    window.onbeforeunload = function(e) {
      if (_this.isUploading) {
        e = e || window.event;
        // 兼容IE8和Firefox 4之前的版本
        if (e) {
          e.returnValue = '关闭提示';
        }
        // Chrome, Safari, Firefox 4+, Opera 12+ , IE 9+
        return '关闭提示';
      }
    };
    this.meetingDescription = '';
  },
  destroyed() {
    window.onbeforeunload = null;
  },
  methods: {
    editMeeting() {
      getEditMeetingInfo({
        meetingId: this.editMeetingId
      }).then(res => {
        if (res.code === 200) {
          const data = res.data;
          this.meetingCategoryType = [stageGroupMap[data.category.id], data.category.id];
          this.meetingGoal = data.goal;
          this.needTime = data.needTime;
          this.ifIpo = data.ifIpo;
          this.subsidiary = data.subsidiary;
          this.relatedCompany = data.relatedCompany;
          // this.dealLeaders = data.dealLeaders || [];
          // this.dealMembers = data.dealMembers || [];
          this.initChecklist = data.checklist;
          this.projectRound = data.roundId || '';
          this.secret = data.secret;
          this.meetingDescription = data.description;
          let supportFlag = false;
          this.supportList.forEach(_ => {
            if (data.departments && data.departments.indexOf(_.id) > -1) {
              _.checked = true;
              supportFlag = true;
            }
          });
          if (!supportFlag) {
            this.supportList.find(_ => _.id === 0).checked = true;
          }
        }
      });
    },
    switchNew(e) {
      let { checked } = e.target;
      this.newRoundChecked = checked;
    },

    getMeetingCategory(value) {
      this.meetingCategoryType = value;
    },
    getMeetingGoal(value) {
      this.meetingGoal = value;
      if ([3, 4, 5].indexOf(value.id) > -1) {
        this.needTime = 120;
      } else {
        this.needTime = 90;
      }
      // this.renderCheckList();
      // let name = value.name;
      // if (name.indexOf('(') !== -1) {
      //   this.voteNode = name.slice(name.indexOf('(') + 1, name.indexOf(')'));
      // } else {
      //   this.voteNode = name;
      // }
    },
    // deleteFile(item, file, index) {
    //   if (this.deletedFileIds.indexOf(file.id) === -1) {
    //     this.deletedFileIds.push(file.id);
    //   }
    //   item.files.splice(index, 1);
    // },
    // renderCheckList() {
    //   getChecklist({
    //     meetingGoal: this.meetingGoal.id,
    //     companyId: this.projectId
    //   }).then(res => {
    //     res.data.forEach(item => {
    //       item.memo = '';
    //       item.files = item.files.filter(file => this.deletedFileIds.indexOf(file.id) === -1);
    //     });
    //     this.checklist = res.data;
    //   });
    // },
    genSubmitData() {
      let isEmpty = false;
      let supportDepartments = this.supportList
        .filter(_ => {
          return _.checked;
        })
        .map(_ => {
          if (_.id === 0) {
            isEmpty = true;
          }
          return _.id;
        })
        .reduce((accumulator, currentValue) => {
          return +accumulator + +currentValue;
        }, 0);
      let emptyCheckList;
      if (this.askMeetingType === 2) {
        emptyCheckList = {
          会议名称不能为空: this.meetingName,
          上会目的不能为空: this.meetingGoal.id,
          会议时间不能为空: this.startTime && this.endTime ? true : null,
          飞书群不能为空: this.groupId
        };
      } else {
        emptyCheckList = {
          // '请选择上会项目是新项目还是已有portfolio follow-on': this.followType,
          一句话描述不能为空: this.meetingDescription,
          上会分类不能为空: this.meetingCategoryType[1],
          项目轮次不能为空: this.projectRound,
          上会目的不能为空: this.meetingGoal.id,
          '公开/保密不能为空': this.secret,
          // 所需时间不能为空: this.needTime,
          上市公司拆分不能为空: this.subsidiary,
          上市公司名称不能为空: this.subsidiary && this.relatedCompany,
          // vote节点不能为空: this.isHasVote && !this.voteNode ? null : true,
          会议类型不能为空: this.meetingType,
          提供独立尽调报告部门不能为空: this.supportShow && supportDepartments === 0 && !isEmpty ? null : true,
          大赛道不能为空: this.bigSector.length === 0 ? null : true
          // 'deal leader 不能为空': this.dealLeaders.length === 0 ? null : true
          // "deal members 不能为空": this.dealMembers.length === 0 ? null : true
        };
      }
      // 融资阶段是seed的必填
      if (this.askMeetingType === 1) {
        emptyCheckList['注册地(区)不能为空'] = this.registerArea;
        emptyCheckList['落地诉求不能为空'] = this.registerRequire;
        emptyCheckList['跟投情况不能为空'] = this.followOnInfo;
      }
      // 如果有烯牛同步的注册地，就不用必填注册地
      if (this.project.registerAreaFromXiniu) {
        delete emptyCheckList['注册地(区)不能为空'];
      }
      if (this.projectInfo.base.financingStage === 1) {
        delete emptyCheckList['跟投情况不能为空'];
      }

      for (let msg in emptyCheckList) {
        if (emptyCheckList[msg] === null || emptyCheckList[msg] === undefined || emptyCheckList[msg] === '') {
          this.$message.error(msg);
          return;
        }
      }
      if (this.mustIpoRow) {
        if (!(this.ifIpo >= 0)) {
          this.$message.error('请选择预计3年内IPO');
          return;
        }
      }
      if (this.askMeetingType !== 2) {
        if (!this.$refs.meetingUpload.validate()) {
          return;
        }
        if (this.supportShow && supportDepartments === 0 && !isEmpty) {
          return;
        }
      }
      let data = {
        companyId: this.projectId,
        dealLeaders: this.projectInfo.member.dls.map(item => {
          return item.id;
        })
      };
      let obj = {};
      if (this.askMeetingType === 2) {
        obj = {
          groupId: this.groupId,
          meetingName: this.meetingName,
          startTime: this.startTime,
          endTime: this.endTime,
          meetingGoal: this.meetingGoal.id,
          registerArea: this.registerArea,
          registerRequire: this.registerRequire,
          followOnInfo: this.followOnInfo
        };
      } else {
        obj = {
          id: this.editMeetingId,
          // companyId: this.projectId,
          ifIpo: this.mustIpoRow ? this.ifIpo : undefined,
          needTime: this.needTime,
          subsidiary: this.subsidiary,
          meetingCategory: this.meetingCategoryType[1],
          roundId: this.projectRound,
          phase: 1,
          meetingGoal: this.meetingGoal.id,
          // dealLeaders: this.projectInfo.member.dls.map(item => {
          //   return item.id;
          // }),
          dealMembers: this.projectInfo.member.dms.map(item => {
            return item.id;
          }),
          // checklist: JSON.stringify(this.checklist),
          // isHasVote: this.isHasVote,
          // voteNode: this.voteNode,
          meetingType: this.meetingType,
          secret: this.secret,
          supportDepartments: supportDepartments,
          description: this.meetingDescription,
          relatedCompany: this.relatedCompany,
          registerArea: this.registerArea,
          registerRequire: this.registerRequire,
          followOnInfo: this.followOnInfo,
          bigSector: this.bigSector
        };
      }
      if (this.showVentureSource) {
        data.sourceType = this.sourceType;
        data.sourceRemark = this.sourceRemark;
        if (!this.sourceType) {
          this.$message.error('请选择首次source 方式');
          return;
        }
      }
      Object.assign(data, obj);
      return data;
    },
    async submit() {
      const submitData = this.genSubmitData();
      if (submitData) {
        this.submitDisable = true;
        try {
          let meetingId = submitData.meetingId;
          // if (!meetingId) {
          //   let res = await askMeeting({ ...submitData, checklist: JSON.stringify([]) });
          //   if (res.code === 200 && res.data) {
          //     meetingId = res.data;
          //   } else {
          //     throw new Error(res.msg);
          //   }
          // }
          // if (meetingId) {
          this.isUploading = true;
          // let checklist = await this.$refs.meetingUpload.getCheckList();
          this.isUploading = false;
          let data = {};
          if (this.askMeetingType === 2) {
            data = {
              meetingType: 2,
              ...submitData
            };
          } else {
            let checklist = await this.$refs.meetingUpload.getCheckList();
            data = {
              meetingType: this.askMeetingType ? 1 : this.meetingType,
              ...submitData,
              checklist: JSON.stringify(checklist),
              meetingId,
              dismissWorkProgress: submitData.meetingId ? false : true
            };
          }
          let res = await askMeeting(data);
          if (res.code === 200) {
            this.$emit('saveMeeting');
          } else {
            throw new Error(res.msg);
          }
        } catch (e) {
          this.isUploading = false;
          this.submitDisable = false;
          this.$message.error(e.message);
        }
      }
    },
    checkChange(index, data) {
      this.$set(this.supportList, index, { ...data, checked: !data.checked });
    },
    DateChange(date, dateString) {
      this.startTime = date[0].unix('X') || '';
      this.endTime = date[1].unix('X') || '';
    },
    async gerGrouplist() {
      try {
        let res = await queryFeishuGroupList({ companyId: this.projectId });
        if (res.code === 200) {
          this.grouplist = res.data;
        }
      } catch (err) {
        console.log(err);
      }
    },
    handleChange(value, e) {
      this.groupId = value;
    },
    meetingTimeChange(time) {
      this.startTime = time[0];
      this.endTime = time[1];
    }
  }
};
</script>

<style lang="less" scoped>
.ask-meeting {
  .spin-container {
    position: fixed;
    background-color: rgba(0, 0, 0, 0.2);
    width: 100vw;
    height: 100vh;
    top: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 100;
    color: white;
  }
  padding: 0 40px;
  // min-height: 500px;
  // height: fit-content;
  .lh-32 {
    line-height: 32px;
  }
  .content-item {
    margin-bottom: 16px;
    display: flex;
    align-items: center;
    .create-vote {
      // width: 300px;
      height: 32px;
      line-height: 32px;
      margin-right: 16px;
    }
    .item-follow-type {
      margin-left: 20px;
    }
    .follow-type {
      margin-left: 4px;
      width: 100px;
    }
    .item-title {
      min-width: 120px;
    }
    .vote {
    }
    .hint {
      margin-left: 20px;
      .hint-text {
        cursor: pointer;
        color: #1892f7;
      }
    }
    .need-time-title {
      width: 90px;
    }
    .need-time {
      width: 60px;
      margin-right: 12px;
    }
    .dealleaders {
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      width: 120px;
      .avatar {
        margin: 0 6px 6px 0;
      }
    }
    .dealmembers-title {
      margin-left: 20px;
      width: 120px;
    }
    .dealmembers {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      width: 250px;
      .avatar {
        margin: 0 6px 6px 0;
      }
    }
  }
  .checklist-container {
    margin-top: 40px;
    .document-title {
      display: flex;
      .title-text {
        color: #1892f7;
      }
      .refresh-btn,
      .upload-btn {
        cursor: pointer;
        background: #1892f7;
        color: #fff;
        border-radius: 2px;
        padding: 2px 4px;
        font-size: 12px;
        width: 100px;
        text-align: center;
        margin-left: 20px;
      }
    }
    .checklist {
      margin-top: 10px;
      .checklist-item {
        display: flex;
        margin-top: 10px;
        .check-title {
          flex: 1;
        }
        .check-files {
          flex: 3;
          display: flex;
          flex-direction: column;
          margin-left: 20px;
          color: #1892f7;
          .file {
            display: flex;
            margin-top: 4px;
            .file-name {
              flex: 5;
            }
            .file-delete {
              flex: 1;
              max-width: 20px;
              height: 20px;
            }
          }
        }
        .check-hint {
          margin-left: 20px;
          flex: 3;
        }
      }
    }
  }

  .bottom-container {
    margin: 20px 0 0 0;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    .hint {
      color: red;
      width: 80%;
    }
    .submit {
      cursor: pointer;
      float: right;
      background: #1892f7;
      color: #fff;
      padding: 2px 4px;
      width: 80px;
      text-align: center;
      border-radius: 4px;
    }
  }

  &::after {
    margin: 0;
    content: '';
    display: block;
    width: 1px;
    height: 1px;
    clear: both;
  }
  .pop-container {
    width: 100px !important;
  }
  .support-div {
    display: flex;
    margin: 4px 0;
    line-height: 1.8;
    // flex-wrap: wrap;
    .checkbox {
      padding-right: 15px;
    }
    .support-title {
      display: flex;
      min-width: 120px;
      // margin-left: 5px;
    }
    .support-content {
      display: flex;
      flex-wrap: wrap;
    }
    .required {
      color: red;
      margin-right: 4px;
    }
  }
  .brief {
    margin-bottom: 4px;
  }
  .new-round {
    margin-left: 12px;
    // margin-top: 5px;
  }
  .secret-info {
    margin-top: 0px;
    font-size: 12px;
    line-height: 32px;
    i {
      color: #1890ff;
      margin: 0 8px 0 -4%;
    }
  }
}
.select {
  width: 200px;
}
.group-select {
  width: 300px;
}
.info {
  font-size: 12px;
  margin-bottom: 10px;
  line-height: 1.8;
  &.sourcing {
    margin-bottom: 8px;
    margin-left: 22%;
  }
  .link {
    color: @blue;
    cursor: pointer;
  }
  .brief-info-icon {
    color: #1890ff;
    margin-right: 4px;
  }
  .category-info-icon {
    color: #1890ff;
    margin: 0 4px 0 12px;
  }
}
.info-hide {
  width: 260px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.flex {
  display: flex;
  align-items: center;
}
.option-container {
  display: flex;
}
.name-content {
  margin-left: 10px;
}
.name {
  font-weight: bold;
}
.description {
  font-size: 12px;
}
.related-company {
  width: 190px;
}
.m-t-8 {
  margin-top: 8px;
}
.w-22 {
  width: 22%;
}
.m-b-8 {
  margin-bottom: 8px;
}
</style>

<style lang="less">
// overlayClassName标签不能带scoped 不用加/deep/
.meeting-category-class {
  .ant-cascader-menu {
    height: auto !important;
  }
}

.askmeeting-info-full {
  width: 300px;
}
</style>
